import { useEffect, useState } from 'react';

const userInteractionEvents = [
  'click',
  'dblclick',
  'mousedown',
  'mouseup',
  'mousemove',
  'wheel',
  'keydown',
  'keyup',
  'keypress',
  'touchstart',
  'touchend',
  'touchmove',
  'pointerdown',
  'pointerup',
  'pointermove',
  'scroll',
  'focus',
  'blur',
  'input',
  'change',
  'submit',
  'contextmenu',
  'resize'
];

export default function useIsPageInteractive(callback) {
  const [isInteractive, setIsInteractive] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const call = () => {
      setIsInteractive(true);

      if (callback) callback();
      controller.abort('Stop firing events');
    };

    userInteractionEvents.forEach(event => {
      window.addEventListener(event, call, { signal: controller.signal });
    });

    return () => {
      controller.abort();
    };
  }, [callback]);

  return isInteractive;
}
